import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { debounce } from 'lodash';
import DateTimePicker from '../../general/DateTimePicker';
import { IconButton, Button, Dropdown } from '../../ui-kit';
import { IconArrowLeft, IconArrowRight, IconLock, IconLockOpen } from '../../ui-kit/icons';

const DashboardDateTimePicker = ({ datetime, onDateChanged, unlockDashboardDatetime }) => {
  const [customDateTime, setCustomDateTime] = useState(moment(datetime.dateTime));
  const [realTime, setRealTime] = useState(!datetime.locked);
  const [show, setShow] = useState(false);

  const dashboardDateTime = realTime ? moment() : customDateTime;

  const lockTime = () => {
    if (!realTime) return;

    setRealTime(false);
  };

  const unlockTime = () => {
    setRealTime(true);
    setCustomDateTime(moment(datetime.dateTime));
    unlockDashboardDatetime();
  };

  const shiftDays = days => {
    const newTime = moment(dashboardDateTime).add(days, 'day');
    if (realTime) setRealTime(false);
    setCustomDateTime(newTime);
  };

  const setCustomDateTimeDebounced = debounce(setCustomDateTime, 1000);

  useEffect(() => {
    if (!realTime) onDateChanged(customDateTime);
  }, [customDateTime]);

  return (
    <>
      {realTime && (
        <Button variant="info" className="me-2" disabled={true}>
          {I18n.t('now')}
        </Button>
      )}
      {realTime || (
        <Dropdown className="btn p-0 mx-1 hidden-print" show={show} onToggle={setShow} autoClose={false}>
          <Dropdown.Toggle variant="info">{customDateTime.format('LLL')}</Dropdown.Toggle>
          <Dropdown.Menu style={{ minWidth: '23rem' }} className="p-3">
            <DateTimePicker
              value={customDateTime}
              onChange={setCustomDateTimeDebounced}
              minutesInterval={15}
              customLabel={I18n.t('just_time')}
            />
            <div className="row mt-2 g-1">
              <div className="col-6">
                <Button variant="secondary w-100" onClick={() => shiftDays(-1)}>
                  <IconArrowLeft /> {I18n.t('previous_day')}
                </Button>
              </div>
              <div className="col-6">
                <Button variant="secondary w-100" onClick={() => shiftDays(1)}>
                  {I18n.t('next_day')} <IconArrowRight />
                </Button>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12 text-end">
                <Button variant="secondary" onClick={() => setShow(false)}>
                  {I18n.t('close')}
                </Button>
              </div>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      )}
      <IconButton
        onClick={realTime ? lockTime : unlockTime}
        fixedWidth
        Icon={realTime ? IconLock : IconLockOpen}
        title={I18n.t('dashboards.lock_time')}
      />
    </>
  );
};

export default DashboardDateTimePicker;
